import axios from "axios";

import integrations from "@/static/integrations";

const ownersStructure = {
	fullname: "",
	nationality: "",
	cep: "",
	street: "",
	number: "",
	complement: "",
	city: "",
	state: "",
	country: "",
	percent: "",
};

const representativeStructure = {
	fullname: "",
	role: "",
	email: "",
	linkedin: "",
	cpf: "",
	rg: "",
	birthday: "",
};

const contractStructure = {
	fullname: "",
	email: "",
	cep: "",
	street: "",
	number: "",
	city: "",
	state: "",
	country: "",
	complement: "",
};

const channelStructure = {
	fullname: "-",
	phone: "",
	email: "",
};

const contactStructure = {
	fullname: "",
	phone: "",
	email: "",
};

const politicalStructure = {
	fullname: "",
	role: "",
	country: "",
};

const passwordEncryption = 22;
const baseUrl = process.env.VUE_APP_BASE_URL;

const multipartHeader = {
	headers: {
		"content-type": "multipart/form-data",
	},
};

const cloneObject = (object) => {
	return Object.assign({}, object);
};

const module = {
	state: () => ({
		step: 1,
		loadingButton: false,
		acceptedPolicy: false,
		personal: {
			id: 0,
			fullname: "",
			cpf: "",
			cnpj: "",
			phone: "",
			email: "",
			access_code: "",
		},
		establishment: {
			company: "",
			company_fantasy: "",
			website: "",
			product: "",
			age: "",
			cnpj: "",
			type: "",
			product_category: "",
			product_description: "",
			product_shipping: "",
			sameAddress: true,
			hasGroup: false,
			exposed: false,
			agree: false,
			group: {
				name: "",
				cnpj: "",
			},
			address: [
				{
					street: "",
					cep: "",
					number: "",
					complement: "",
					city: "",
					state: "",
					country: "",
				},
				{
					street: "",
					cep: "",
					number: "",
					complement: "",
					city: "",
					state: "",
					country: "",
				},
			],
		},
		bankAccount: {
			name: "",
			cnpj: "",
			bank: "",
			number: "",
			agency: "",
			account: "",
		},
		ownersAndContacts: {
			owner: [cloneObject(ownersStructure)],
			representative: [cloneObject(representativeStructure)],
			contract: [cloneObject(contractStructure)],
			billing: [cloneObject(contactStructure)],
			technical: [cloneObject(contactStructure)],
			emergency: [cloneObject(contactStructure)],
			channel: [cloneObject(channelStructure)],
			support: [cloneObject(contactStructure)],
			refund: [cloneObject(contactStructure)],
			political: [cloneObject(politicalStructure)],
		},
		pci: {
			integration: "",
			conformity: true,
		},
		documents: {
			cpf: [],
			addressPartners: [],
			cnpj: [],
			address: [],
			secondAddress: [],
			contract: [],
			socialContract: [],
			pci: [],
			representative: [],
		},
		uploadedDocuments: {
			cpf: [],
			addressPartners: [],
			cnpj: [],
			address: [],
			secondAddress: [],
			contract: [],
			socialContract: [],
			pci: [],
			representative: [],
		},
		confirmModal: {
			form: "",
			key: "",
			type: null,
		},
	}),
	actions: {
		async checkToken({ state, commit }) {
			let formData = new FormData();

			formData.append("email", state.personal.email);
			formData.append("access_code", state.personal.access_code);

			return await axios
				.post(baseUrl + "?class=Personal&method=checkAccessToken", formData, multipartHeader)
				.then((res) => {
					if (res.status == 200 && res.data > 0) {
						commit("setPersonal", { key: "id", value: res.data });
						sessionStorage.setItem("pid", btoa(res.data * passwordEncryption));
						return true;
					}
					return false;
				})
				.catch((err) => console.log(err));
		},
		async resendToken({ state }) {
			let formData = new FormData();
			formData.append("email", state.personal.email);
			formData.append("cnpj", state.personal.cnpj);

			return await axios
				.post(baseUrl + "?class=Personal&method=resendAccessToken", formData, multipartHeader)
				.then((res) => {
					if (res.status == 200 && res.data > 0) {
						return true;
					}
					return false;
				})
				.catch((err) => console.log(err));
		},
		async submitForm({ state }, form) {
			let formData = new FormData();
			let controller = "Form";
			let method = "";

			switch (form) {
				case 0:
					formData.append("personal_id", sessionStorage.getItem("pid"));
					formData.append("reset_token", state.step == 0 ? 0 : 1);

					formData.append("fullname", state.personal.fullname);
					formData.append("cpf", state.personal.cpf);
					formData.append("phone", state.personal.phone);
					formData.append("email", state.personal.email);
					formData.append("cnpj", state.personal.cnpj);
					formData.append("step", state.step);
					formData.append(
						"account_manager_abbreviation",
						localStorage.getItem("account_manager_abbreviation"),
					);

					controller = "Personal";
					method = "savePersonalData";
					break;
				case 1:
					formData.append("personal_id", sessionStorage.getItem("pid"));
					formData.append("step", state.step);

					formData.append("company", state.establishment.company);
					formData.append("company_fantasy", state.establishment.company_fantasy);

					formData.append("website", state.establishment.website);
					formData.append("product", state.establishment.product);
					formData.append("age", state.establishment.age);
					formData.append("cnpj", state.establishment.cnpj);
					formData.append("type", state.establishment.type);

					if (state.establishment.hasGroup) {
						formData.append("group_name", state.establishment.group.name);
						formData.append("group_cnpj", state.establishment.group.cnpj);
					}

					formData.append("product_category", state.establishment.product_category);

					if (state.establishment.product_description) {
						formData.append("product_description", state.establishment.product_description);
					}

					formData.append("product_shipping", state.establishment.product_shipping);

					formData.append("ma_cep", state.establishment.address[0].cep);
					formData.append("ma_street", state.establishment.address[0].street);
					formData.append("ma_number", state.establishment.address[0].number);
					formData.append("ma_complement", state.establishment.address[0].complement);
					formData.append("ma_city", state.establishment.address[0].city);
					formData.append("ma_state", state.establishment.address[0].state);
					formData.append("ma_country", state.establishment.address[0].country);

					if (!state.establishment.sameAddress) {
						formData.append("sa_cep", state.establishment.address[1].cep);
						formData.append("sa_street", state.establishment.address[1].street);
						formData.append("sa_number", state.establishment.address[1].number);
						formData.append("sa_complement", state.establishment.address[1].complement);
						formData.append("sa_city", state.establishment.address[1].city);
						formData.append("sa_state", state.establishment.address[1].state);
						formData.append("sa_country", state.establishment.address[1].country);
					}

					controller = "Establishment";
					method = "saveEstablishmentData";
					break;
				case 2:
					formData.append("personal_id", sessionStorage.getItem("pid"));
					formData.append("step", state.step);

					state.ownersAndContacts.owner.forEach((owner, index) => {
						formData.append("owner_fullname_" + index, owner.fullname);
						formData.append("owner_nationality_" + index, owner.nationality);
						formData.append("owner_cep_" + index, owner.cep);
						formData.append("owner_street_" + index, owner.street);
						formData.append("owner_number_" + index, owner.number);
						formData.append("owner_complement_" + index, owner.complement);
						formData.append("owner_city_" + index, owner.city);
						formData.append("owner_state_" + index, owner.state);
						formData.append("owner_country_" + index, owner.country);
						formData.append("owner_percent_" + index, owner.percent);
					});

					state.ownersAndContacts.representative.forEach((representative, index) => {
						formData.append("representative_fullname_" + index, representative.fullname);
						formData.append("representative_role_" + index, representative.role);
						formData.append("representative_email_" + index, representative.email);
						formData.append("representative_linkedin_" + index, representative.linkedin);
						formData.append("representative_cpf_" + index, representative.cpf);
						formData.append("representative_rg_" + index, representative.rg);
						formData.append("representative_birthday_" + index, representative.birthday);
					});

					state.ownersAndContacts.contract.forEach((contract, index) => {
						formData.append("contract_fullname_" + index, contract.fullname);
						formData.append("contract_email_" + index, contract.email);
						formData.append("contract_cep_" + index, contract.cep);
						formData.append("contract_street_" + index, contract.street);
						formData.append("contract_number_" + index, contract.number);
						formData.append("contract_city_" + index, contract.city);
						formData.append("contract_state_" + index, contract.state);
						formData.append("contract_country_" + index, contract.country);
						formData.append("contract_complement_" + index, contract.complement);
					});

					state.ownersAndContacts.billing.forEach((billing, index) => {
						formData.append("billing_fullname_" + index, billing.fullname);
						formData.append("billing_phone_" + index, billing.phone);
						formData.append("billing_email_" + index, billing.email);
					});

					state.ownersAndContacts.technical.forEach((technical, index) => {
						formData.append("technical_fullname_" + index, technical.fullname);
						formData.append("technical_phone_" + index, technical.phone);
						formData.append("technical_email_" + index, technical.email);
					});

					state.ownersAndContacts.emergency.forEach((emergency, index) => {
						formData.append("emergency_fullname_" + index, emergency.fullname);
						formData.append("emergency_phone_" + index, emergency.phone);
						formData.append("emergency_email_" + index, emergency.email);
					});

					state.ownersAndContacts.channel.forEach((channel, index) => {
						formData.append("channel_fullname_" + index, channel.fullname);
						formData.append("channel_phone_" + index, channel.phone);
						formData.append("channel_email_" + index, channel.email);
					});

					state.ownersAndContacts.support.forEach((support, index) => {
						formData.append("support_fullname_" + index, support.fullname);
						formData.append("support_phone_" + index, support.phone);
						formData.append("support_email_" + index, support.email);
					});

					state.ownersAndContacts.refund.forEach((refund, index) => {
						formData.append("refund_fullname_" + index, refund.fullname);
						formData.append("refund_phone_" + index, refund.phone);
						formData.append("refund_email_" + index, refund.email);
					});

					state.ownersAndContacts.political.forEach((political, index) => {
						if (political.fullname) {
							formData.append("political_fullname_" + index, political.fullname);
							formData.append("political_role_" + index, political.role);
							formData.append("political_country_" + index, political.country);
						}
					});

					controller = "Contacts";
					method = "saveContactsData";
					break;
				case 3:
					formData.append("personal_id", sessionStorage.getItem("pid"));
					formData.append("step", state.step);

					formData.append("integration", state.pci.integration.text);
					formData.append("conformity", state.pci.conformity);

					controller = "Integration";
					method = "saveIntegrationData";
					break;
				case 4:
					return true;
				case 5:
					formData.append("personal_id", sessionStorage.getItem("pid"));
					formData.append("step", state.step);

					formData.append("name", state.bankAccount.name);
					formData.append("cnpj", state.bankAccount.cnpj);
					formData.append("bank", state.bankAccount.bank);
					formData.append("number", state.bankAccount.number);
					formData.append("agency", state.bankAccount.agency);
					formData.append("account", state.bankAccount.account);

					controller = "Bank";
					method = "saveBankAccount";
					break;
			}

			return await axios
				.post(baseUrl + "?class=" + controller + "&method=" + method, formData, multipartHeader)
				.then((res) => {
					if (res.status == 200) {
						if (method == "savePersonalData" && state.step !== 0) {
							sessionStorage.removeItem("pid");
						}
						return true;
					}
					return false;
				})
				.catch((err) => console.log(err));
		},
		async getPersonalData({ commit, state }) {
			let formData = new FormData();
			formData.append("pid", sessionStorage.getItem("pid"));
			formData.append("step", state.step);

			await axios
				.post(baseUrl + "?class=Personal&method=getPersonalData", formData, multipartHeader)
				.then((res) => {
					if (res.status == 200) {
						commit("setPersonal", {
							key: "fullname",
							value: res.data["fullname"],
						});

						commit("setPersonal", { key: "cpf", value: res.data["cpf"] });
						commit("setPersonal", { key: "phone", value: res.data["phone"] });
						commit("setPersonal", { key: "email", value: res.data["email"] });
						commit("setPersonal", { key: "cnpj", value: res.data["cnpj"] });
						commit("setEstablishment", { key: "cnpj", value: res.data["cnpj"] });

						commit("setStep", parseInt(res.data["step"]));
					}
				})
				.catch((err) => console.log(err));
		},
		async getEstablishmentData({ commit, state }) {
			let formData = new FormData();
			formData.append("pid", sessionStorage.getItem("pid"));
			formData.append("step", state.step);

			await axios
				.post(baseUrl + "?class=Establishment&method=getEstablishmentData", formData, multipartHeader)
				.then((res) => {
					if (res.status == 200) {
						commit("setEstablishment", {
							key: "company",
							value: res.data["company"],
						});

						commit("setEstablishment", {
							key: "company_fantasy",
							value: res.data["company_fantasy"],
						});

						commit("setEstablishment", {
							key: "website",
							value: res.data["website"],
						});

						commit("setEstablishment", {
							key: "product",
							value: res.data["product"],
						});

						commit("setEstablishment", {
							key: "age",
							value: res.data["age"],
						});

						// commit("setEstablishment", {
						//   key: "cnpj",
						//   value: res.data["cnpj"],
						// });

						commit("setEstablishment", {
							key: "product_category",
							value: res.data["product_category"],
						});

						commit("setEstablishment", {
							key: "product_description",
							value: res.data["product_description"],
						});

						commit("setEstablishment", {
							key: "product_shipping",
							value: res.data["product_shipping"],
						});

						commit("setEstablishment", {
							key: "type",
							value: res.data["establishment_type"],
						});

						if (res.data["company"]) {
							commit("setEstablishment", {
								key: "agree",
								value: false,
							});
						}

						if (res.data["address"] && res.data["address"].length > 1) {
							commit("setEstablishment", { key: "sameAddress", value: false });
						}

						if (res.data["address"]) {
							res.data["address"].forEach((addrs) => {
								commit("setEstablishmentAddress", {
									index: addrs["type"],
									key: "cep",
									value: addrs["cep"],
								});

								commit("setEstablishmentAddress", {
									index: addrs["type"],
									key: "street",
									value: addrs["street"],
								});

								commit("setEstablishmentAddress", {
									index: addrs["type"],
									key: "number",
									value: addrs["number"],
								});

								commit("setEstablishmentAddress", {
									index: addrs["type"],
									key: "complement",
									value: addrs["complement"],
								});

								commit("setEstablishmentAddress", {
									index: addrs["type"],
									key: "city",
									value: addrs["city"],
								});

								commit("setEstablishmentAddress", {
									index: addrs["type"],
									key: "state",
									value: addrs["state"],
								});

								commit("setEstablishmentAddress", {
									index: addrs["type"],
									key: "country",
									value: addrs["country"],
								});
							});
						}

						if (res.data["group_name"] && res.data["group_cnpj"]) {
							commit("setEstablishment", { key: "hasGroup", value: true });

							commit("setEstablishmentGroup", {
								key: "name",
								value: res.data["group_name"],
							});

							commit("setEstablishmentGroup", {
								key: "cnpj",
								value: res.data["group_cnpj"],
							});
						}
					}
				})
				.catch((err) => console.log(err));
		},
		async getContactsData({ commit, state }) {
			let formData = new FormData();
			formData.append("pid", sessionStorage.getItem("pid"));
			formData.append("step", state.step);

			await axios
				.post(baseUrl + "?class=Contacts&method=getContactsData", formData, multipartHeader)
				.then((res) => {
					if (res.status == 200) {
						if (res.data.owner && res.data.owner.length) {
							commit("clearContacts", "owner");
							res.data.owner.forEach((contact) => {
								commit("addContactToForm", {
									form: "owner",
									structure: contact,
								});
							});
						}

						if (res.data.representative && res.data.representative.length) {
							commit("clearContacts", "representative");
							res.data.representative.forEach((contact) => {
								commit("addContactToForm", {
									form: "representative",
									structure: contact,
								});
							});
						}

						if (res.data.contract && res.data.contract.length) {
							commit("clearContacts", "contract");
							res.data.contract.forEach((contact) => {
								commit("addContactToForm", {
									form: "contract",
									structure: contact,
								});
							});
						}

						if (res.data.billing && res.data.billing.length) {
							commit("clearContacts", "billing");
							res.data.billing.forEach((contact) => {
								commit("addContactToForm", {
									form: "billing",
									structure: contact,
								});
							});
						}

						if (res.data.technical && res.data.technical.length) {
							commit("clearContacts", "technical");
							res.data.technical.forEach((contact) => {
								commit("addContactToForm", {
									form: "technical",
									structure: contact,
								});
							});
						}

						if (res.data.emergency && res.data.emergency.length) {
							commit("clearContacts", "emergency");
							res.data.emergency.forEach((contact) => {
								commit("addContactToForm", {
									form: "emergency",
									structure: contact,
								});
							});
						}

						if (res.data.channel && res.data.channel.length) {
							commit("clearContacts", "channel");
							res.data.channel.forEach((contact) => {
								commit("addContactToForm", {
									form: "channel",
									structure: contact,
								});
							});
						}

						if (res.data.support && res.data.support.length) {
							commit("clearContacts", "support");
							res.data.support.forEach((contact) => {
								commit("addContactToForm", {
									form: "support",
									structure: contact,
								});
							});
						}

						if (res.data.refund && res.data.refund.length) {
							commit("clearContacts", "refund");
							res.data.refund.forEach((contact) => {
								commit("addContactToForm", {
									form: "refund",
									structure: contact,
								});
							});
						}

						if (res.data.political && res.data.political.length) {
							commit("clearContacts", "political");
							res.data.political.forEach((contact) => {
								commit("addContactToForm", {
									form: "political",
									structure: contact,
								});
							});
							commit("setEstablishment", { key: "exposed", value: true });
						}
					}
				})
				.catch((err) => console.log(err));
		},
		async updateStep(fn, step) {
			let formData = new FormData();
			formData.append("pid", sessionStorage.getItem("pid"));
			formData.append("step", step);

			await axios.post(baseUrl + "?class=Personal&method=updateStep", formData, multipartHeader);
		},
		async getIntegrationData({ commit, state }) {
			let formData = new FormData();
			formData.append("pid", sessionStorage.getItem("pid"));
			formData.append("step", state.step);

			await axios
				.post(baseUrl + "?class=Integration&method=getIntegrationData", formData, multipartHeader)
				.then((res) => {
					if (res.status == 200) {
						const integration = integrations.filter((int) => {
							return int.text === res.data["integration"];
						})[0];

						commit("setPci", {
							key: "integration",
							value: integration,
						});

						commit("setPci", {
							key: "conformity",
							value: res.data["conformity"] == 1 ? true : false,
						});
					}
				})
				.catch((err) => console.log(err));
		},
		async getUploadedFiles({ commit, state }) {
			let formData = new FormData();
			formData.append("pid", sessionStorage.getItem("pid"));
			formData.append("step", state.step);

			await axios
				.post(baseUrl + "?class=Files&method=getDocuments", formData, multipartHeader)
				.then((res) => {
					if (res.status == 200) {
						res.data.forEach((file) => {
							commit("addUploadedDocument", { form: file.form, value: file });
						});
					}
				})
				.catch((err) => console.log(err));
		},
		async getBankAccountData({ commit, state }) {
			let formData = new FormData();
			formData.append("pid", sessionStorage.getItem("pid"));
			formData.append("step", state.step);

			await axios
				.post(baseUrl + "?class=Bank&method=getBankAccount", formData, multipartHeader)
				.then((res) => {
					if (res.status == 200) {
						commit("setBankAccount", {
							key: "name",
							value: res.data["company"],
						});

						commit("setBankAccount", { key: "cnpj", value: res.data["cnpj"] });

						commit("setBankAccount", {
							key: "bank",
							value: res.data["bank_name"],
						});

						commit("setBankAccount", {
							key: "number",
							value: res.data["bank_number"],
						});

						commit("setBankAccount", {
							key: "agency",
							value: res.data["agency"],
						});

						commit("setBankAccount", {
							key: "account",
							value: res.data["account"],
						});
					}
				})
				.catch((err) => console.log(err));
		},
		addContact({ commit }, key) {
			let structure;
			switch (key) {
				case "owner":
					structure = ownersStructure;
					break;
				case "representative":
					structure = representativeStructure;
					break;
				case "contract":
					structure = contractStructure;
					break;
				case "political":
					structure = politicalStructure;
					break;
				default:
					structure = contactStructure;
					break;
			}
			commit("addContactToForm", { form: key, structure });
		},
		removeContact({ commit }) {
			commit("removeContactToForm");
		},
		removeDocument({ commit }) {
			commit("removeDocumentToForm");
		},
		updateContacts({ commit }, { form, value }) {
			commit("updateContactsToForm", { form, value });
		},
		async deleteDocumentFromServer(context, file) {
			context.commit("setLoadingButton", true);

			let formData = new FormData();
			formData.append("pid", sessionStorage.getItem("pid"));

			formData.append("fid", file.id);
			formData.append("form", file.form);
			formData.append("step", context.state.step);

			await axios
				.post(baseUrl + "?class=Files&method=deleteDocument", formData, multipartHeader)
				.then((res) => {
					if (res.status == 200) {
						context.commit("setLoadingButton", false);

						return true;
					}

					context.commit("setLoadingButton", false);
				})
				.catch((err) => {
					context.commit("setLoadingButton", false);

					return false;
				});
		},
		sendFile(context, [files, fileType]) {
			context.commit("setLoadingButton", true);

			let success;
			let form;

			switch (fileType) {
				case "social_contract":
					form = "socialContract";
					break;
				case "second_address":
					form = "secondAddress";
					break;
				case "address_partners":
					form = "addressPartners";
					break;
				default:
					form = fileType;
					break;
			}

			let formData = new FormData();

			formData.append("pid", sessionStorage.getItem("pid"));
			formData.append("form", fileType);
			formData.append("step", context.state.step);

			files.forEach((file) => {
				formData.append("file", file);

				success = axios
					.post(baseUrl + "?class=Files&method=saveDocument", formData, multipartHeader)
					.then((res) => {
						if (res.status == 200) {
							const fileId = res.data;

							context.state.uploadedDocuments[form].push({
								filename: file.name,
								form: fileType,
								id: fileId,
							});

							context.commit("setLoadingButton", false);
							return true;
						}

						context.commit("setLoadingButton", false);
						return false;
					})
					.catch(() => {
						context.commit("setLoadingButton", false);
						return false;
					});
			});

			return success;
		},
	},
	mutations: {
		setLoadingButton(state, data) {
			state.loadingButton = data;
		},
		setStep(state, step) {
			state.step = step;
		},
		setPersonal(state, { key, value }) {
			state.personal[key] = value;
		},
		setEstablishment(state, { key, value }) {
			state.establishment[key] = value;
		},
		setEstablishmentGroup(state, { key, value }) {
			state.establishment.group[key] = value;
		},
		setEstablishmentAddress(state, { index, key, value }) {
			state.establishment.address[index][key] = value;
		},
		setBankAccount(state, { key, value }) {
			state.bankAccount[key] = value;
		},
		setContactData(state, { form, index, key, value }) {
			if (form == "channel" && index > 0) {
				state.ownersAndContacts[form][index]["fullname"] = "-";
			}

			state.ownersAndContacts[form][index][key] = value;
		},
		setPci(state, { key, value }) {
			state.pci[key] = value;
		},
		setDocuments(state, { form, value }) {
			state.documents[form] = value;
		},
		addUploadedDocument(state, { form, value }) {
			if (form == "social_contract") {
				form = "socialContract";
			}

			if (form == "second_address") {
				form = "secondAddress";
			}

			if (form == "address_partners") {
				form = "addressPartners";
			}

			state.uploadedDocuments[form].push(value);
		},
		addContactToForm(state, { form, structure }) {
			let key = state.ownersAndContacts[form].length;
			while (state.ownersAndContacts[form].indexOf(key) !== -1) {
				key++;
			}
			state.ownersAndContacts[form].push(cloneObject(structure));
		},
		clearContacts(state, form) {
			state.ownersAndContacts[form] = [];
		},
		removeContactToForm(state) {
			state.ownersAndContacts[state.confirmModal.form].splice(
				state.ownersAndContacts[state.confirmModal.form].indexOf(state.confirmModal.key),
				1,
			);
		},
		removeDocumentToForm(state) {
			state[state.confirmModal.type][state.confirmModal.form].splice(
				state[state.confirmModal.type][state.confirmModal.form].indexOf(state.confirmModal.key),
				1,
			);
		},
		updateContactsToForm(state, { form, value }) {
			state.ownersAndContacts[form] = value;
		},
		setConfirmForm(state, { form, key, type = false }) {
			state.confirmModal.type = type;
			state.confirmModal.form = form;
			state.confirmModal.key = key;
		},
	},
};

export default module;
